import request from "@/utils/service";

// 登入
export const getLogin = (params) => request.post(`/login`,params)

// 登出
export const logout = (params) => request.post(`/logout`,params)

export function roles(data) {
  return request({
    url: '/role/list',
    method: 'post',
    data
  })
}

export function role(data) {
  return request({
    url: '/role/detail',
    method: 'post',
    data
  })
}

export function all(data) {
  return request({
    url: '/role/all',
    method: 'post',
    data
  })
}

export function syncPermissions(data) {
  return request({
    url: '/role/syncPermissions',
    method: 'post',
    data
  })
}

export function syncRoles(data) {
  return request({
    url: '/admin/syncRoles',
    method: 'post',
    data
  })
}

export function create(data) {
  return request({
    url: '/role/create',
    method: 'post',
    data
  })
}

export function update(data) {
  return request({
    url: '/role/update',
    method: 'post',
    data
  })
}

export function deleted(data) {
  return request({
    url: '/role/delete',
    method: 'post',
    data
  })
}
export function tree(data) {
  return request({
    url: '/permission/tree',
    method: 'post',
    data
  })
}

export function orderList(data) {
  return request({
    url: '/order/list',
    method: 'post',
    data
  })
}

export function roomOrderList(data) {
  return request({
    url: '/order/roomOrderList',
    method: 'post',
    data
  })
}

export function tabooGroupList(data) {
  return request({
    url: '/taboo/tabooList',
    method: 'post',
    data
  })
}

export function tabooSelect(data) {
  return request({
    url: '/taboo/all',
    method: 'post',
    data
  })
}

export function getAddress(data) {
  return request({
    url: '/index/regionTree',
    method: 'post',
    data
  })
}

export function changeRoom(data) {
  return request({
    url: '/order/changeRoom',
    method: 'post',
    data
  })
}

export function todayOrderCount(data) {
  return request({
    url: '/order/todayOrderCount',
    method: 'post',
    data
  })
}

export function usableRoom(data) {
  return request({
    url: '/index/usableRoom',
    method: 'post',
    data
  })
}

export function todayOrderList(data) {
  return request({
    url: '/order/todayOrderList',
    method: 'post',
    data
  })
}

export function tomorrowChooseCount(data) {
  return request({
    url: '/order/tomorrowChooseCount',
    method: 'post',
    data
  })
}

export function agencyAdmin(data) {
  return request({
    url: '/agencyAdmin/list',
    method: 'post',
    data
  })
}

export function getInfo(data) {
  return request({
    url: '/me',
    method: 'post',
    data
  })
}

export function roleAll(data) {
  return request({
    url: '/role/all',
    method: 'post',
    data
  })
}

export function createUser(data) {
  return request({
    url: '/agencyAdmin/create',
    method: 'post',
    data
  })
}

export function updateUser(data) {
  return request({
    url: '/agencyAdmin/update',
    method: 'post',
    data
  })
}

export function agencyMessage(data) {
  return request({
    url: '/agencyMessage/list',
    method: 'post',
    data
  })
}


export function agencyMessageDetail(data) {
  return request({
    url: '/agencyMessage/detail',
    method: 'post',
    data
  })
}

export function addRoom(data) {
  return request({
    url: '/order/addRoom',
    method: 'post',
    data
  })
}

export function editRoom(data) {
  return request({
    url: '/order/editRoom',
    method: 'post',
    data
  })
}

export function roomList(data) {
  return request({
    url: '/order/roomList',
    method: 'post',
    data
  })
}








